module.exports = __webpack_public_path__ + "static/media/cancel.b086c4a6.png";